if (customElements.get('variant-selects')) {
  const variantPill = document.querySelector('.product-form__input--pill');
  const currentVariant = document.querySelector('.product-variant-id');

  if(variantPill) {
    const btns = variantPill.querySelectorAll('label');
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => {
          setCustomMedia()
        }, 300);
      })
    });
  }

  document.addEventListener('DOMContentLoaded', () => { setCustomMedia() })

  function setCustomMedia() {
    const customMedias = document.querySelectorAll('.product__custom-media-item');
    customMedias.forEach(media => {
      // console.log(media.dataset.variantId)
      if(currentVariant.value == media.dataset.variantId) {
        media.classList.remove('hidden')
      } else {
        media.classList.add('hidden')
      }
    })
  }
}